import * as types from "../actions/actionTypes";
import { sort } from "../lib/listMethods";

const DEFAULT_ACCOUNT_TITLE = {
  name: "",
  description: "",
  serial_accounting_codes: [],
  sub_accounting_codes: []
};
const initialState = {
  loading: false,
  error: "",
  data: [],
  isFetched: false,

  typesForDefaultList: [],
  typesForDefaultListLoading: false,
  typesForDefaultListError: "",

  defaultListData: [],
  defaultListLoading: false,
  defaultListError: "",
  defaultListProcessing: false,
  defaultListModalStatus: false,

  importExcelTeamModalStatus: false,

  last_item: "",
  storeProcessing: false,
  storeStatus: false,
  removeProcessing: false,

  showLoading: false,
  showError: "",
  account_title: DEFAULT_ACCOUNT_TITLE,
  processing: false
};

const AccountTitle = (state = initialState, action) => {
  let data;
  switch (action.type) {
    case types.GET_ACCOUNT_TITLE_REQUEST:
      return { ...state, loading: true, error: "", isFetched: false };
    case types.GET_ACCOUNT_TITLE_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        isFetched: true
      };
    case types.GET_ACCOUNT_TITLE_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.SHOW_ACCOUNT_TITLE_REQUEST:
      return {
        ...state,
        account_title: DEFAULT_ACCOUNT_TITLE,
        showLoading: true,
        showError: ""
      };
    case types.SHOW_ACCOUNT_TITLE_SUCCESS:
      return { ...state, account_title: action.payLoad, showLoading: false };
    case types.SHOW_ACCOUNT_TITLE_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.UPDATE_ACCOUNT_TITLE_REQUEST:
      return { ...state, storeProcessing: true };
    case types.UPDATE_ACCOUNT_TITLE_SUCCESS:
      data = [];
      if (state.data.length) {
        data = state.data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      return {
        ...state,
        account_title: action.payLoad,
        storeProcessing: false,
        data: sort(data, true, "name")
      };
    case types.UPDATE_ACCOUNT_TITLE_FAILURE:
      return { ...state, storeProcessing: false };

    case types.STORE_ACCOUNT_TITLE_REQUEST:
      return { ...state, storeProcessing: true };
    case types.STORE_ACCOUNT_TITLE_SUCCESS:
      data = [...state.data];
      let founded = false;
      if (data.length) {
        data = data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            founded = true;
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      if (!founded) {
        data.push(action.payLoad);
      }
      return {
        ...state,
        storeProcessing: false,
        last_item: action.payLoad,
        data: sort(data, true, "name"),
        // accountTitle: accountTitle,
        storeStatus: true
      };
    case types.STORE_ACCOUNT_TITLE_FAILURE:
      return { ...state, storeProcessing: false, storeStatus: false };

    case types.REMOVE_ACCOUNT_TITLE_REQUEST:
      return { ...state, removeProcessing: true };
    case types.REMOVE_ACCOUNT_TITLE_SUCCESS:
      data = JSON.parse(JSON.stringify(state.data)); // because deepCopy is needed :)
      data = data.filter(item => item.id !== Number(action.payLoad));
      return { ...state, data: data, removeProcessing: false };
    case types.REMOVE_ACCOUNT_TITLE_FAILURE:
      return { ...state, removeProcessing: false };

    case types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_REQUEST:
      return {
        ...state,
        typesForDefaultList: [],
        typesForDefaultListLoading: true,
        typesForDefaultListError: ""
      };
    case types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS:
      return {
        ...state,
        typesForDefaultList: action.payLoad,
        typesForDefaultListLoading: false
      };
    case types.GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_FAILURE:
      return {
        ...state,
        typesForDefaultListLoading: false,
        typesForDefaultListError: action.error
      };

    case types.GET_DEFAULTS_ACCOUNT_TITLE_REQUEST:
      return {
        ...state,
        defaultListLoading: true,
        defaultListError: "",
        defaultListData: []
      };
    case types.GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS:
      return {
        ...state,
        defaultListData: action.payLoad,
        defaultListLoading: false
      };
    case types.GET_DEFAULTS_ACCOUNT_TITLE_FAILURE:
      return {
        ...state,
        defaultListLoading: false,
        defaultListError: action.error
      };

    case types.STORE_DEFAULT_ACCOUNT_TITLE_REQUEST:
      return {
        ...state,
        defaultListProcessing: true
      };
    case types.STORE_DEFAULT_ACCOUNT_TITLE_SUCCESS:
      return {
        ...state,
        defaultListProcessing: false,
        defaultListModalStatus: false,
        data: action.payLoad
      };
    case types.STORE_DEFAULT_ACCOUNT_TITLE_FAILURE:
      return {
        ...state,
        defaultListProcessing: false
      };
    case types.TOGGLE_DEFAULT_ACCOUNT_TITLE_LIST_MODAL:
      return {
        ...state,
        defaultListModalStatus: action.status
      };
    case types.TOGGLE_IMPORT_EXCEL_TEAM_MODAL:
      return {
        ...state,
        importExcelTeamModalStatus: action.status
      };
    case types.IMPORT_FILE_ACCOUNT_TITLE_REQUEST:
      return { ...state, processing: true };
    case types.IMPORT_FILE_ACCOUNT_TITLE_SUCCESS:
      return { ...state, processing: false, importExcelTeamModalStatus: false };
    case types.IMPORT_FILE_ACCOUNT_TITLE_FAILURE:
      return { ...state, processing: false };

    case types.CLEAR_ACCOUNT_TITLE_LIST:
      return { ...state, data: [], isFetched: false };
    case types.EMPTY_LAST_ACCOUNT_TITLE_ITEM:
      return { ...state, last_item: "" };

    case types.STORE_SUB_ACCOUNT_TITLE_REQUEST:
      return { ...state, storeProcessing: true };
    case types.STORE_SUB_ACCOUNT_TITLE_SUCCESS:
      data = state.data.map(accountTitle =>
        accountTitle.id === Number(action.payLoad.parent_id)
          ? {
              ...accountTitle,
              sub_account_titles: [
                ...accountTitle.sub_account_titles,
                action.payLoad
              ]
            }
          : accountTitle
      );
      let lastItem = data.filter(
        accountTitle => accountTitle.id === Number(action.payLoad.parent_id)
      );
      return {
        ...state,
        storeProcessing: false,
        last_item: action.payLoad,
        account_title: lastItem[0],
        data: data,
        storeStatus: true
      };
    case types.STORE_SUB_ACCOUNT_TITLE_FAILURE:
      return { ...state, storeProcessing: false, storeStatus: false };

    case types.UPDATE_SUB_ACCOUNT_TITLE_REQUEST:
      return { ...state, storeProcessing: true };
    case types.UPDATE_SUB_ACCOUNT_TITLE_SUCCESS:
      data = state.data.map(accountTitle =>
        accountTitle.id === Number(action.payLoad.parent_id)
          ? {
              ...accountTitle,
              sub_account_titles: accountTitle.sub_account_titles.map(
                subAccountTitle =>
                  subAccountTitle.id === Number(action.payLoad.id)
                    ? action.payLoad
                    : subAccountTitle
              )
            }
          : accountTitle
      );
      return {
        ...state,
        storeProcessing: false,
        account_title: data.filter(
          accountTitle => accountTitle.id === Number(action.payLoad.parent_id)
        )[0],
        data: data
      };
    case types.UPDATE_SUB_ACCOUNT_TITLE_FAILURE:
      return { ...state, storeProcessing: false, storeStatus: false };

    case types.REMOVE_SUB_ACCOUNT_TITLE_REQUEST:
      return { ...state, removeProcessing: true };
    case types.REMOVE_SUB_ACCOUNT_TITLE_SUCCESS:
      data = state.data.map(accountTitle =>
        accountTitle.id === Number(action.payLoad.accountTitleId)
          ? {
              ...accountTitle,
              sub_account_titles: accountTitle.sub_account_titles.filter(
                subAccountTitle =>
                  subAccountTitle.id !== Number(action.payLoad.id)
              )
            }
          : accountTitle
      );
      return {
        ...state,
        removeProcessing: false,
        data,
        account_title: data.filter(
          accountTitle =>
            accountTitle.id === Number(action.payLoad.accountTitleId)
        )[0]
      };
    case types.REMOVE_SUB_ACCOUNT_TITLE_FAILURE:
      return { ...state, removeProcessing: false };

    default:
      return state;
  }
};

export default AccountTitle;
